import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { SortingOptions } from '../../pages/DiscoverPage';
import { SortDirection } from '../../service/lobby';

export interface SortOption {
    attribute: SortingOptions;
    direction: SortDirection;
}

type SortButtonsProps = {
    disabled?: boolean;
    searchText: string;
} & (
    | {
          sortOption: SortOption;
          setSortOption: (value: React.SetStateAction<SortOption>) => void;
      }
    | {
          sortOption: SortOption | undefined;
          setSortOption: (value: React.SetStateAction<SortOption | undefined>) => void;
      }
);

export const SortButtons: React.FC<SortButtonsProps> = ({
    disabled,
    searchText,
    sortOption,
    setSortOption,
}) => {
    return !searchText ? (
        <Flex className={'sort-options'}>
            {Object.values(SortingOptions).map((option) => (
                <Button
                    className={'sort-option-button'}
                    key={option}
                    isActive={option === sortOption?.attribute}
                    disabled={disabled}
                    onClick={() =>
                        option === sortOption?.attribute
                            ? setSortOption({
                                  attribute: option,
                                  direction: (sortOption.direction + 1) % 2,
                              })
                            : setSortOption({ attribute: option, direction: SortDirection.DESC })
                    }
                    rightIcon={
                        <Box
                            as={
                                sortOption?.direction === SortDirection.ASC
                                    ? ChevronUpIcon
                                    : ChevronDownIcon
                            }
                            className={'sort-direction-indicator'}
                        />
                    }
                >
                    <Text>{isMobile ? option.replace(/number/i, 'no.') : option}</Text>
                </Button>
            ))}
        </Flex>
    ) : (
        <></>
    );
};
